import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { all_routes } from '../../router/all_routes';
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from '../../../core/common/collapse-header/collapse-header';
import { API } from '../../../common/Constants';
import { getAPIHeaders, getFormattedDateDDMMYYYY } from '../../../common/Utils';
import useFetch from '../../../hooks/useFetch';
import { Leave } from '../../../types/dataModel';
import PreLoader from '../../../core/common/preLoader';
import DeleteModal from '../../../core/modals/deleteModal';
import SuccessModal from '../../../core/modals/successModal';
import CopyRightInfo from '../../../core/common/copyRightInfo';
import { useAccess } from '../../../hooks/accessContext';

const Leaves = () => {
  const  { hasAttendEdit } = useAccess()
  const { isLoading, callFetch } = useFetch();
  const [leaves, setLeaves] = useState<Leave[]>();
  const [totalLeaves, setTotalLeaves] = useState<number>(0)
  const [pendingLeaves, setPendingLeaves] = useState<number>(0)
  const [approvedLeaves, setApprovedLeaves] = useState<number>(0)
  const [deniedLeaves, setDeniedLeaves] = useState<number>(0)
  const [editItem, setEditItem] = useState<any>({
            id:undefined, 
            message: undefined,
  })
  useEffect(() => {
    fetch()
  }, []);

  const fetch = () => {
      callFetch(API.LEAVES,
        'GET',
        getAPIHeaders(),
        null,
        null
      ).then((res:Leave[])=>{
        setLeaves(res)
        if(res){
          let totalCnt = res?.length;
          let pendingCnt =0;
          let deniedCnt = 0;
          let approvedCnt = 0;
  
          res.forEach((item: Leave)=>{
            if(item.status === 'PENDING'){
              pendingCnt = pendingCnt+1;
            } else if(item.status === 'APPROVED'){
              approvedCnt = approvedCnt +1 ;
            } else if(item.status === 'DENIED'){
              deniedCnt = deniedCnt +1 ;
            }
          })
          setTotalLeaves(totalCnt)
          setDeniedLeaves(deniedCnt)
          setPendingLeaves(pendingCnt)
          setApprovedLeaves(approvedCnt)
        }
      });
  }


  const update = (status:string) => {
    callFetch(API.LEAVES,
      'PUT',
      getAPIHeaders(),
      null,
      {
        id: editItem.id,
        status: status
      }
    ).then(()=>{
      fetch()
    });
  }

  const columns = [
    {
      title: "Applied By",
      dataIndex: "appliedBy",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <div className="ms-2">
            <h6 className="fw-medium">
              {record.appliedBy}
            </h6>
            <span className="fs-12 fw-normal ">Applied On: {getFormattedDateDDMMYYYY(record.createdOn)}</span>
          </div>
        </div>


      ),
      sorter: (a: any, b: any) => a.appliedBy?.localeCompare(b.appliedBy),
    },
    {
      title: "Description",
      dataIndex: "description",
      sorter: (a: any, b: any) => a.description?.localeCompare(b.description),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => (
        text === 'APPROVED' ?
          <span className="badge badge-soft-success d-inline-flex align-items-center badge-sm">
              {text}
          </span>
          :
          text === 'DENIED' ?
          <span className="badge badge-soft-danger d-inline-flex align-items-center badge-sm">
            {text}
          </span>
          :
          text === 'PENDING' ?
          <span className="badge badge-soft-warning d-inline-flex align-items-center badge-sm">
            {text}
          </span>
          :
          <></>
        ),
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
      defaultSortOrder: 'descend',
    },
    {
      title: "From",
      dataIndex: "startDate",
      sorter: (a: any, b: any) => a.startDate - b.startDate,
      render: (text: String, record: any) => (
        <>
        {getFormattedDateDDMMYYYY(record.startDate)}
        </>
      ),
    },
    {
      title: "To",
      dataIndex: "endDate",
      sorter: (a: any, b: any) => a.endDate - b.endDate,
      render: (text: String, record: any) => (
          <>
          {getFormattedDateDDMMYYYY(record.endDate)}
          </>
      ),
    },
    {
      title: "Approved/Denied By",
      dataIndex: "approvedBy",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <div className="ms-2">
            <h6 className="fw-medium">
              {record.approvedBy}
            </h6>
            {
              record.approvedBy
              ?
                <span className="fs-12 fw-normal ">
                {record.status === 'APPROVED' ? 'Approved On: ' : record.status === 'DENIED' ? 'Denied On: ' : 'Updated On: '} 
                {getFormattedDateDDMMYYYY(record.updatedOn)}
                </span>
              :<></>
            }
            
          </div>
        </div>


      ),
      sorter: (a: any, b: any) => a.approvedBy?.localeCompare(b.approvedBy),
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text:string, record:any) => (
        <div className="action-icon d-inline-flex">
          <button
            hidden={!hasAttendEdit()}
            className="me-2 btn btn-success btn-sm"
            data-bs-toggle="modal" data-inert={true}
            data-bs-target="#success_modal"
            disabled={record.status !== 'PENDING'}
            onClick={()=>{
              setEditItem({
                id: record?.id,
                message: `Approve leave applied by ${record?.appliedBy} from ${getFormattedDateDDMMYYYY(record.startDate)} to ${getFormattedDateDDMMYYYY(record.endDate)}.`
              })
            }}
          >
            Approve
          </button>
          <button
            hidden={!hasAttendEdit()}
            className='btn btn-danger btn-sm'
            data-bs-toggle="modal" data-inert={true}
            data-bs-target="#delete_modal"
            disabled={record.status !== 'PENDING'}
            onClick={()=>{
              setEditItem({
                id: record?.id,
                message: `Deny leave applied by ${record?.appliedBy} from ${getFormattedDateDDMMYYYY(record.startDate)} to ${getFormattedDateDDMMYYYY(record.endDate)}.`
              })
            }}
          >
            Deny
          </button>
        </div>
      ),
    },
  ]

  const renderLeaveStatCards = () => {
    return (          
    <div className="row">
      <div className="col-xl-3 col-md-6">
        <div className="card bg-blue-img">
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-2">
                  <span className="avatar avatar-md rounded-circle bg-white d-flex align-items-center justify-content-center">
                    <i className="ti ti-user text-info fs-18" />
                  </span>
                </div>
              </div>
              <div className="text-end">
                <p className="mb-1">Total Leaves</p>
                <h4>{totalLeaves}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-3 col-md-6">
        <div className="card bg-green-img">
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-2">
                  <span className="avatar avatar-md rounded-circle bg-white d-flex align-items-center justify-content-center">
                    <i className="ti ti-user-check text-success fs-18" />
                  </span>
                </div>
              </div>
              <div className="text-end">
                <p className="mb-1">Approved Leaves</p>
                <h4>{approvedLeaves}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-3 col-md-6">
        <div className="card bg-yellow-img">
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-2">
                  <span className="avatar avatar-md rounded-circle bg-white d-flex align-items-center justify-content-center">
                    <i className="ti ti-user-question  text-warning fs-18" />
                  </span>
                </div>
              </div>
              <div className="text-end">
                <p className="mb-1">Pending Leaves</p>
                <h4>{pendingLeaves}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-3 col-md-6">
        <div className="card bg-pink-img">
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-2">
                  <span className="avatar avatar-md rounded-circle bg-white d-flex align-items-center justify-content-center">
                    <i className="ti ti-user-exclamation text-pink fs-18" />
                  </span>
                </div>
              </div>
              <div className="text-end">
                <p className="mb-1">Denied Leaves</p>
                <h4>{deniedLeaves}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>)
  }

  return (
    <>
      <PreLoader showLoader={isLoading} />
      <SuccessModal 
        heading="Approve Leave"
        message={editItem.message}
        btnText='Yes, Approve'
        onConfirm={()=>(update('APPROVED'))}
        renderIcon={()=>(<i className="ti ti-thumb-up fs-36" />)}
      />
      <DeleteModal 
            heading="Deny Leave"
            message={editItem.message}
            btnText='Yes, Deny'
            onDelete={()=>(update('DENIED'))}
            renderIcon={()=>(<i className="ti ti-thumb-down fs-36" />)}
      />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Leaves</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Employee</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Leaves
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">     
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Leaves Info */}
          {renderLeaveStatCards()}
          {/* /Leaves Info */}
          {/* Leaves list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Leave List</h5>
            </div>
            <div className="card-body p-0">
              <Table dataSource={leaves || []} columns={columns} Selection={false} refresh={fetch} />
            </div>
          </div>
          {/* /Leaves list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <CopyRightInfo/>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>


  )
}

export default Leaves